export default __webpack_public_path__ + "static/media/productList4.de69cbb0.png";